function formatProfessionalsInitialCouponDiscount(data) {
  return data.map(([id, email, ordersCount]) => ({
    id,
    email,
    ordersCount
  }));
}

async function getProfessionalsInitialCouponDiscount() {
  try {
    let res = await fetch(
      "https://data.heroku.com/dataclips/elejdgecttpztyxbxrcizttqwrky.json"
    );
    res = await res.json();
    return formatProfessionalsInitialCouponDiscount(res.values);
  } catch (e) {
    throw "Ocorreu um erro os profissionais com cupom de desconto!";
  }
}

export default {
  getProfessionalsInitialCouponDiscount
};



// WEBPACK FOOTER //
// ./src/api/dataclips.js